import { IconProps } from '@diritto/common/style/icon';

export const ContestBadgeIcon = ({ size = 31 }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={(size * 16) / 31} viewBox="0 0 31 16" fill="none">
    <g clipPath="url(#clip0_19793_16412)">
      <rect width="31" height="16" rx="2" fill="url(#paint0_linear_19793_16412)" />
      <g filter="url(#filter0_d_19793_16412)">
        <path
          d="M9.44401 8.81301V4.02501H10.596V8.81301H9.44401ZM8.80501 7.27401L8.93101 8.27301C7.59001 8.48001 6.03301 8.57901 4.77301 8.57901H3.49501L3.43201 7.57101H4.35901V5.39301H3.55801V4.37601H8.59801V5.39301H7.80601V7.40001C8.13901 7.36401 8.48101 7.31901 8.80501 7.27401ZM6.68101 7.49901V5.39301H5.47501V7.56201C5.85301 7.55301 6.25801 7.52601 6.68101 7.49901ZM9.44401 10.316H4.79101V9.27201H10.596V12.512H9.44401V10.316Z"
          fill="white"
        />
        <path
          d="M17.7532 7.03101H16.9252V9.96501H15.8722V4.10601H16.9252V6.01401H17.7532V4.01601H18.8422V10.235H17.7532V7.03101ZM15.1882 6.52701V6.66201C15.1882 8.21901 14.4052 8.97501 13.3612 8.97501C12.3172 8.97501 11.5162 8.21901 11.5162 6.66201V6.52701C11.5162 4.95201 12.3172 4.19601 13.3612 4.19601C14.4052 4.19601 15.1882 4.95201 15.1882 6.52701ZM12.5692 6.53601V6.65301C12.5692 7.51701 12.9292 7.96701 13.3612 7.96701C13.7842 7.96701 14.1442 7.51701 14.1442 6.65301V6.53601C14.1442 5.65401 13.7842 5.20401 13.3612 5.20401C12.9292 5.20401 12.5692 5.65401 12.5692 6.53601ZM14.1262 9.70401V11.378H19.1392V12.422H12.9742V9.70401H14.1262Z"
          fill="white"
        />
        <path
          d="M20.3924 8.72301L19.9514 7.70601C21.9044 7.08501 22.7594 6.39201 22.8764 5.73501H20.4374V4.71801H22.8944V3.89001H24.0374V4.71801H26.4314V5.73501H24.0284C24.0194 5.96901 23.9654 6.19401 23.8754 6.41001L26.9084 7.72401L26.4134 8.72301L23.2094 7.31901C22.6244 7.85001 21.7064 8.31801 20.3924 8.72301ZM19.4744 9.31701H27.3944V10.361H25.5044V12.512H24.3524V10.361H22.5254V12.512H21.3734V10.361H19.4744V9.31701Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_19793_16412"
        x="-6.56799"
        y="-6.10999"
        width="43.9623"
        height="28.622"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19793_16412" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19793_16412" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_19793_16412"
        x1="23.5"
        y1="2.24749e-07"
        x2="-4.96064e-07"
        y2="16"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#915FFF" />
        <stop offset="1" stopColor="#E8A45D" />
      </linearGradient>
      <clipPath id="clip0_19793_16412">
        <rect width="31" height="16" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
